import { getApi, postApi } from '../../utils/api'

export function getGooglePlaceGeocode({ search, ...restParams }) {
  return getApi({
    endpoint: 'api/google/maps/geocode/',
    params: {
      ...(search ? { address: search } : null),
      ...restParams,
    },
  })
}

// params shoud be { latlng: value }
export function getGooglePlaceReverseGeocode(params) {
  return getApi({
    endpoint: 'api/google/maps/reverse-geocode/',
    params,
  })
}

export function getGooglePlacesAutocomplete(data) {
  return postApi({
    data,
    endpoint: 'api/google/maps/places-autocomplete/',
  })
}
